import { render, staticRenderFns } from "./PartNumberUpdateDetailsContainer.vue?vue&type=template&id=e25c5ffc"
import script from "./PartNumberUpdateDetailsContainer.vue?vue&type=script&lang=js"
export * from "./PartNumberUpdateDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports